var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.496,
    height: 24.37,
    viewBox: "0 0 19.496 24.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-document",
    d: "M23.44,10.373V9.5A7.986,7.986,0,0,0,15.992,2H13.846c-1.894,0-4.544.25-6.312.375a3.264,3.264,0,0,0-3.156,3C4.252,7.374,4,11.248,4,14.122c0,2.749.252,6.624.379,8.748a3.362,3.362,0,0,0,3.03,3.124c1.767.125,4.418.375,6.312.375s4.544-.25,6.311-.375a3.362,3.362,0,0,0,3.03-3.124c.126-2,.379-5.874.379-8.748a36.77,36.77,0,0,0,0-3.749Zm-8.458,8.5H13.467v1.5a.99.99,0,0,1-1.01,1,.924.924,0,0,1-1.01-1v-1.5H9.933a.991.991,0,0,1-1.01-1,.925.925,0,0,1,1.01-1h1.515v-1.5a.991.991,0,0,1,1.01-1,.924.924,0,0,1,1.01,1v1.5h1.515a1,1,0,1,1,0,2Zm2.525-9.5a1.527,1.527,0,0,1-1.515-1.5v-4a6.048,6.048,0,0,1,5.554,5.5Z",
    transform: "translate(-4 -2)",
    fill: "#3b56a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/add-document.66bcc30d988525b152d70d472bc13c03.svg";
export { ForwardRef as ReactComponent };